var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var brief = ref.brief;
    var contact = ref.contact;
    var productDetails = ref.productDetails;
    var affiliateLinks = ref.affiliateLinks;
    var discountCodes = ref.discountCodes;
    var briefFields = ref.briefFields;
    var isLoading = ref.isLoading;
    var steps = ref.steps;
    var currentStep = ref.currentStep;
    var isPreview = ref.isPreview;
    var errorMessage = ref.errorMessage;
    var completeBrief = ref.completeBrief;
    var restartBrief = ref.restartBrief;
return [_c('activation-brief-overview-view',{attrs:{"brief":brief,"contact":contact,"productDetails":productDetails,"affiliate-links":affiliateLinks,"discount-codes":discountCodes,"brief-fields":briefFields,"is-preview":isPreview,"steps":steps,"current-step":currentStep,"is-loading":isLoading,"error-message":errorMessage,"restart-brief":restartBrief},on:{"complete-brief":completeBrief}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }